// src/components/AppShell.jsx
// Header (brand, user, sign out) and page container shared by the signed-in pages.
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { displayNameOf, signOutUser, subscribeToProfileChanges } from '../auth';
import { useToast } from './Toast';
import { TrophyIcon } from './icons';
import SyncControl from '../sync/SyncControl';

export const initialsOf = (name) =>
    (name || '?')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join('') || '?';

function AppShell({ user, children }) {
    const navigate = useNavigate();
    const toast = useToast();
    const [, redraw] = useState(0); // (the name can change on the account page)
    useEffect(() => subscribeToProfileChanges(() => redraw((count) => count + 1)), []);

    const handleSignOut = async () => {
        try {
            await signOutUser();
            navigate('/');
        } catch (error) {
            console.error('Error signing out:', error);
            toast.error('Could not sign out. Please try again.');
        }
    };

    return (
        <>
            <header className="app-header">
                <div className="container app-header-inner">
                    <Link className="brand" to="/dashboard">
                        <span className="brand-mark">
                            <TrophyIcon size={18} />
                        </span>
                        <span className="brand-name">Tournamental</span>
                    </Link>
                    {user && (
                        <div className="user">
                            <SyncControl />
                            <Link className="user-link" to="/account" aria-label="Your account">
                                <span className="avatar" aria-hidden="true">
                                    {initialsOf(displayNameOf(user))}
                                </span>
                                <span className="user-name">{displayNameOf(user)}</span>
                                <span className="user-account-word">Account</span>
                            </Link>
                            {!user.isGuest && ( // (a guest has nothing to sign out of: they sign in)
                                <button className="btn btn-ghost btn-sm" onClick={handleSignOut}>
                                    Sign out
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </header>
            <main className="container main">{children}</main>
        </>
    );
}

export default AppShell;
